var Backbone = require('backbone');
var Marionette = require('backbone.marionette');

var CommonUtils = require('../../utils/common-utils.js');
var Constants = require("../../utils/constants");

var Radio = require('backbone.radio');
var notificationsChannel = Radio.channel('notifications');
var actionsChannel = Radio.channel('actions');
var tablesFilterPreferencesChannel = Radio.channel('tablesFilterPreferencesChannel');

var MedsidePatientsCollections = require('../../collections/medside-patients-collection');
var TableSettingsManager = require('../../views/common/table-settings-manager');
var TableColumnFiltersView = require("../../views/common/table-column-filters-view");
var utils = new CommonUtils();

var OrganizationPatientAuditsTableRowView = Marionette.View.extend({
    tagName: 'tr',
    template: require('../../templates/organizations/organization-patients-audits-row.html'),
    ui: {},

    events: {},

    templateContext: function () {
        var that = this;
        var changeDate = that.model.get('changedate');
        return {
            canEdit: that.canEdit,
            changeuser: that.model.get('changeuser'),
            comment: that.model.get('comment'),
            changeDate: changeDate != undefined && changeDate != ''
            && !isNaN(changeDate) && changeDate != 0
                ? that.utils.longToDateTimeFormatted(changeDate, "MM/DD/YYYY") : '-'
        }
    },

    initialize: function (options) {
        var that = this;
        this.canEdit = options.canEdit;
        this.utils = new CommonUtils();
    },

    onRender: function () {

    }
});

var OrganizationPatientAuditsTableBody = Marionette.CollectionView.extend({
    tagName: 'tbody',
    childView: OrganizationPatientAuditsTableRowView,
    emptyView: EmptyView,
    collectionEvents: {},
    childViewEvents: {},
    initialize: function (options) {
        this.collection = new Backbone.Collection(options.collection);
    }
});

var OrganizationPatientPopoverView = Marionette.View.extend({
    template: require('../../templates/organizations/organization-patients-popover.html'),

    regions: {
        body: {
            el: '[name="audits-popover"]',
            replaceElement: true
        }
    },

    templateContext: function () {
        var that = this;
        return {
            reason: that.reason,
            comment: that.comment,
            hasAudits: that.auditList && that.auditList.length > 0 ? true : false
        }
    },

    initialize: function (options) {
        this.reason = options.reason;
        this.comment = options.comment;
        this.auditList = options.audits;
    },

    onRender: function () {
        var that = this;
        that.showChildView('body', new OrganizationPatientAuditsTableBody({
            collection: that.auditList,
            canEdit: that.canEdit
        }));
    }
});

var OrganizationPatientPopoverViewJF = Marionette.View.extend({
    template: require('../../templates/organizations/organization-patients-jf-popover.html'),

    regions: {
        body: {
            el: 'tbody',
            replaceElement: true
        },
    },

    ui: {
        sortable: '.sortableR'
    },

    events: {
        'click @ui.sortable': 'headerSorting',
    },

    templateContext: function () {
    },

    initialize: function (options) {
        this.jfList = new Backbone.Collection(options.list);
        this.utils = new CommonUtils();
    },

    onRender: function () {
        var that = this;
        that.showChildView('body', new OrganizationPatientPopoverViewJFTableBody({
            collection: that.jfList,
            canEdit: that.canEdit
        }));
    },

    headerSorting: function (event) {
        var that = this;
        var sortField = event.target.id;
        var byAsc = $(event.target).children('div').hasClass('glyphicon-triangle-bottom');

        that.ui.sortable.each(function () {
            $(this).children('div').removeClass('glyphicon glyphicon-triangle-bottom');
            $(this).children('div').removeClass('glyphicon glyphicon-triangle-top');
        });
        if (byAsc)
            $(event.target).children('div').addClass('glyphicon glyphicon-triangle-top');
        else
            $(event.target).children('div').addClass('glyphicon glyphicon-triangle-bottom');

        that.jfList.comparator = function (model1, model2) {
            if (byAsc)
                return (model1.get(sortField) || '') > (model2.get(sortField) || '') ? 1 : -1;
            else
                return (model1.get(sortField) || '') > (model2.get(sortField) || '') ? -1 : 1;
        };
        that.jfList.sort();
    }
});

var OrganizationPatientPopoverViewJfVisits = Marionette.View.extend({
    template: require('../../templates/organizations/organization-patients-jf-visits-popover.html'),

    regions: {
        body: {
            el: 'tbody',
            replaceElement: true
        },
    },

    ui: {
        sortable: '.sortableR'
    },

    events: {
        'click @ui.sortable': 'headerSorting',
    },

    templateContext: function () {
    },

    initialize: function (options) {
        this.jfList = new Backbone.Collection(options.list);
        this.utils = new CommonUtils();
    },

    onRender: function () {
        var that = this;
        that.showChildView('body', new OrganizationPatientPopoverViewJfVisitsTableBody({
            collection: that.jfList,
            canEdit: that.canEdit
        }));
        window.setTimeout(function () {
            that.headerSorting2($('#start'), "start", false);
        }, 500);
    },

    headerSorting: function (event) {
        var that = this;
        var sortField = event.target.id;
        var byAsc = $(event.target).children('div').hasClass('glyphicon-triangle-bottom');

        that.ui.sortable.each(function () {
            $(this).children('div').removeClass('glyphicon glyphicon-triangle-bottom');
            $(this).children('div').removeClass('glyphicon glyphicon-triangle-top');
        });
        if (byAsc)
            $(event.target).children('div').addClass('glyphicon glyphicon-triangle-top');
        else
            $(event.target).children('div').addClass('glyphicon glyphicon-triangle-bottom');

        that.jfList.comparator = function (model1, model2) {
            if (byAsc)
                return (model1.get(sortField) || '') > (model2.get(sortField) || '') ? 1 : -1;
            else
                return (model1.get(sortField) || '') > (model2.get(sortField) || '') ? -1 : 1;
        };
        that.jfList.sort();
    },

    headerSorting2: function (target, sortField, byAsc) {
        var that = this;

        that.ui.sortable.each(function () {
            $(this).children('div').removeClass('glyphicon glyphicon-triangle-bottom');
            $(this).children('div').removeClass('glyphicon glyphicon-triangle-top');
        });
        if (byAsc)
            target.children('div').addClass('glyphicon glyphicon-triangle-top');
        else
            target.children('div').addClass('glyphicon glyphicon-triangle-bottom');

        that.jfList.comparator = function (model1, model2) {
            if (byAsc)
                return (model1.get(sortField) || '') > (model2.get(sortField) || '') ? 1 : -1;
            else
                return (model1.get(sortField) || '') > (model2.get(sortField) || '') ? -1 : 1;
        };
        that.jfList.sort();
    }
});

var OrganizationPatientPopoverViewJFRowView = Marionette.View.extend({
    tagName: 'tr',
    template: require('../../templates/organizations/organization-patients-jf-row.html'),

    ui: {
        canceled: '.rns-canceled-doc',
        created: '.rns-created-doc'
    },

    events: {
        'click @ui.canceled': 'openCanceled',
        'click @ui.created': 'openCreated',
    },

    templateContext: function () {
    },

    initialize: function (options) {
        this.utils = new CommonUtils();
    },

    onRender: function () {
    },

    openCanceled: function () {
        var that = this;
        that.doIfDocExists(function (docId) {
            window.open(docId);
        }, 'canceled_docs');
    },

    openCreated: function () {
        var that = this;
        that.doIfDocExists(function (docId) {
            window.open(docId);
        }, 'created_docs');
    },

    doIfDocExists: function (fn, docType) {
        var that = this;
        var params = [];

        that.model.get(docType).split(',').forEach(function (aliasDoc) {
            params.push("alias=" + aliasDoc);
        });

        $.ajax({
            type: "GET",
            url: '/api/document/preview?' + params.join('&'),
            statusCode: {
                200: function (response) {
                    if (response && response[0] && response[0].id) {
                        if (response.length == 1)
                            fn("/api/document/view/" + response[0].id);
                        else {
                            fn("#documents?" + params.join('&'));
                        }

                    }
                    else
                        $.notify("This Document was not found in R&S", "error");

                },
                503: function (e) {
                    notificationsChannel.request('show:notification', e.responseJSON);

                },
                401: function (e) {
                    actionsChannel.request("redirect:to:login");

                },
                400: function (e) {
                    $.notify("This Document was not found in R&S", "error");
                }
            }
        });
    }

});

var OrganizationPatientPopoverViewJfVisitsRowView = Marionette.View.extend({
    tagName: 'tr',
    template: require('../../templates/organizations/organization-patients-jf-visits-row.html'),

    templateContext: function () {
        var that = this;
        this.utils = new CommonUtils();
        return {
            formatDate: function (dt) {
                return (dt == '' || dt == null || dt == 0 ? '' : that.utils.longToDateTimeFormatted(Number(dt), 'MM/DD/YYYY'));
            }
        }
    },

    initialize: function (options) {
        this.utils = new CommonUtils();
    },

    onRender: function () {
    }


});

var OrganizationPatientPopoverViewJFTableBody = Marionette.CollectionView.extend({
    tagName: 'tbody',
    childView: OrganizationPatientPopoverViewJFRowView,
    emptyView: EmptyView,

    collectionEvents: {},

    childViewEvents: {},

    initialize: function (options) {
        this.collection = options.collection;
        this.canEdit = options.canEdit;
    },

    childViewOptions: function () {
        return {
            canEdit: this.canEdit,
        };
    }
});

var OrganizationPatientPopoverViewJfVisitsTableBody = Marionette.CollectionView.extend({
    tagName: 'tbody',
    childView: OrganizationPatientPopoverViewJfVisitsRowView,
    emptyView: EmptyView,

    collectionEvents: {},

    childViewEvents: {},

    initialize: function (options) {
        this.collection = options.collection;
        this.canEdit = options.canEdit;
    },

    childViewOptions: function () {
        return {
            canEdit: this.canEdit,
        };
    }
});

var OrganizationPatientsView = Marionette.View.extend({
    template: require('../../templates/organizations/organization-patients.html'),
    tagName: 'div',
    className: 'patients-table',

    regions: {
        body: {
            el: 'tbody',
            replaceElement: true
        },

        settingModule: {
            el: '#setting-module',
            replaceElement: true
        },

        //filter regions in column caption
        patientNameFilter: '#patient_name',
        referralDateFilter: '#referral_date',
        socFilter: '#soc',
        transferFilter: '#transfer_date',
        statusFilter: '#status',
        admitFilter: '#admit',
        mdFilter: '#md',
        locationFilter: '#location',
        jencareCoordinatorsFilter: '#jencare_coordinators',
        insuranceFilter: '#insurance',
        intakeFilter: '#intake',
        cmCnFilter: '#cm_sn'
    },

    ui: {
        exportToPdf: '#export-to-pdf',
        exportToCsv: '#export-to-csv',
        patientsCount: '#patients-count',
        sortable: '.sortable'
    },

    events: {
        'click @ui.exportToPdf': 'onExportToPdf',
        'click @ui.exportToCsv': 'onExportToCsv',
        'click @ui.sortable': 'reorder'
    },

    childViewEvents: {
        'filter:changed': 'onFilterChanged',
        'filters:loaded': 'onFiltersReloaded'
    },


    templateContext: function () {
        var that = this;
        return {
            isSimple: that.isSimple,
            patientsCount: that.patientsCount,
            placeholder: that.placeholder,
            settings: that.settings,
            selectedTableFiltersId: that.selectedTableFiltersId,
            variant: that.variant
        }
    },


    initialize: function (options) {
        var that = this;
        this.utils = new CommonUtils();
        this.utils.showSpinner();
        this.orgs = [];
        this.settings = [];
        this.selectedTableFiltersId = "";
        this.params = $.deparam(window.location.hash.replace('#organization/' + options.id + '/patients', '').replace('?', ''));
        var orgParams = this.params['org'];
        this.isSimple = this.params['isSimple'] || false;
        this.variant = this.params['variant'] || "";
        this.from = this.params['from'];
        this.to = this.params['to'];

        if (Array.isArray(orgParams)) {
            for (var ind in orgParams) {
                this.orgs.push(orgParams[ind]);
            }
        } else {
            this.orgs.push(orgParams);
        }

        this.id = options.id;

        this.collection = new MedsidePatientsCollections([], {
            id: options.id,
            orgs: that.orgs,
            variant: that.variant,
            from: that.from,
            to: that.to
        });

        if (that.variant == "referral")
            that.reportTableName = 'organization-patients-report-referral';
        else
            that.reportTableName = 'organization-patients-report';
        that.tableFilterPreferences = {
            tableColumnFilters: [],
            sortField: "patient_name",
            sortDirection: "ASC"
        };
        this.filterFunctions = {};
    },

    onRender: function () {
        var that = this;

        this.collection.fetch({
            success: function () {
                that.tableReDrawPack();
                that.utils.hideSpinner();
            },
            error: function (obj, response) {
                that.utils.hideSpinner();
                that.triggerMethod('server:error', response.responseText);
            }
        });

        that.showChildView('settingModule', new TableSettingsManager({
            table: that
        }));
    },

    tableReDrawPack: function () {
        var that = this;
        that.resort(that.collection);
        that.renderPatientsTableBody(that.collection);
        that.renderColumnFilters();
        that.renderSortColumns();
    },

    renderPatientsTableBody: function (collection) {
        var that = this;

        that.ui.patientsCount.text(' (' + collection.length + ')');

        that.patientsTableBody = new PatientsTableBody({
            collection: collection,
            isSimple: that.isSimple,
            variant: that.variant
        });
        that.showChildView('body', that.patientsTableBody);
    },

    renderSortColumns: function () {
        var that = this;
        var sortField = that.tableFilterPreferences.sortField;
        var sortDirection = that.tableFilterPreferences.sortDirection;
        $('.sort-icon').removeClass("glyphicon glyphicon-triangle-top glyphicon-triangle-bottom");
        var currentSortEl = $("#" + sortField).parent().children(':first-child');

        if (sortDirection == "ASC") {
            currentSortEl.addClass("glyphicon glyphicon-triangle-top");
        } else {
            currentSortEl.addClass("glyphicon glyphicon-triangle-bottom");
        }
    },

    reorder: function (event) {
        var that = this;
        var sortFieldName = $(event.target).next().attr("id");
        if (this.tableFilterPreferences.sortField == sortFieldName) {
            this.tableFilterPreferences.sortDirection = this.tableFilterPreferences.sortDirection == "ASC" ? "DESC" : "ASC";
        } else {
            this.tableFilterPreferences.sortField = sortFieldName;
            this.tableFilterPreferences.sortDirection = "ASC";
        }

        this.renderSortColumns();
        this.resort(this.patientsTableBody.getCollection());
        this.patientsTableBody.render();
    },

    resort: function (collection) {
        collection.sortByFieldAndDirection(this.tableFilterPreferences.sortField, this.tableFilterPreferences.sortDirection);
    },

    renderColumnFilters: function () {

        var that = this;

        that.showChildView("patientNameFilter", new TableColumnFiltersView({
            filter: that.findFiltersForColumn("patient_name") || {
                column: "patient_name",
                dataType: "string",
                filterType: "select",
                value: null
            },
            'list': that.getAggregateTypes(this.collection, 'patient_name', 'patient_name')
        }));

        that.showChildView("socFilter", new TableColumnFiltersView({
            filter: that.findFiltersForColumn("soc") || {
                column: "soc",
                dataType: "date",
                filterType: "interval",
                from: null,
                to: null
            }
        }));

        if (that.variant != 'referral') {
            that.showChildView("transferFilter", new TableColumnFiltersView({
                filter: that.findFiltersForColumn("transfer_date") || {
                    column: "transfer_date",
                    dataType: "date",
                    filterType: "interval",
                    from: null,
                    to: null
                }
            }));

            that.showChildView("statusFilter", new TableColumnFiltersView({
                filter: that.findFiltersForColumn("status") || {
                    column: "status",
                    dataType: "date",
                    filterType: "interval",
                    from: null,
                    to: null
                }
            }));
        }


        if (!that.isSimple) {
            that.showChildView("referralDateFilter", new TableColumnFiltersView({
                filter: that.findFiltersForColumn("referral_date") || {
                    column: "referral_date",
                    dataType: "date",
                    filterType: "interval",
                    from: null,
                    to: null
                }
            }));

            that.showChildView("admitFilter", new TableColumnFiltersView({
                filter: that.findFiltersForColumn("admit") || {
                    column: "admit",
                    dataType: "string",
                    filterType: "select",
                    value: null
                },
                'list': that.getAggregateTypes(this.collection, 'admit', 'admit')
            }));

            that.showChildView("mdFilter", new TableColumnFiltersView({
                filter: that.findFiltersForColumn("md") || {
                    column: "md",
                    dataType: "string",
                    filterType: "select",
                    value: null
                },
                'list': that.getAggregateTypes(this.collection, 'md', 'md')
            }));

            that.showChildView("locationFilter", new TableColumnFiltersView({
                filter: that.findFiltersForColumn("location") || {
                    column: "location",
                    dataType: "string",
                    filterType: "select",
                    value: null
                },
                'list': that.getAggregateTypes(this.collection, 'location', 'location')
            }));

            that.showChildView("jencareCoordinatorsFilter", new TableColumnFiltersView({
                filter: that.findFiltersForColumn("jencare_coordinators") || {
                    column: "jencare_coordinators",
                    dataType: "string",
                    filterType: "select",
                    value: null
                },
                'list': that.getAggregateTypes(this.collection, 'jencare_coordinators', 'jencare_coordinators')
            }));

            that.showChildView("insuranceFilter", new TableColumnFiltersView({
                filter: that.findFiltersForColumn("insurance") || {
                    column: "insurance",
                    dataType: "string",
                    filterType: "select",
                    value: null
                },
                'list': that.getAggregateTypes(this.collection, 'insurance', 'insurance')
            }));

            that.showChildView("intakeFilter", new TableColumnFiltersView({
                filter: that.findFiltersForColumn("intake") || {
                    column: "intake",
                    dataType: "string",
                    filterType: "select",
                    value: null
                },
                'list': that.getAggregateTypes(this.collection, 'intake', 'intake')
            }));

            that.showChildView("cmCnFilter", new TableColumnFiltersView({
                filter: that.findFiltersForColumn("cm_sn") || {
                    column: "cm_sn",
                    dataType: "string",
                    filterType: "select",
                    value: null
                },
                'list': that.getAggregateTypes(this.collection, 'cm_sn', 'cm_sn')
            }));
        }
    },

    getAggregateTypes: function (collection, fieldName, fieldValue) {
        var result = [];
        collection.each(function (model, index, list) {
            if (
                model.get(fieldName) &&
                model.get(fieldValue) &&
                result.filter(function (e) {
                    return e.name == model.get(fieldName) && e.value == model.get(fieldValue);
                }).length == 0
            ) {
                result.push({name: model.get(fieldName), value: model.get(fieldValue)});
            }
        })
        return result;
    },

    findFiltersForColumn: function (column) {
        return _.find(this.tableFilterPreferences.tableColumnFilters, function (columnWithFilter) {
            return columnWithFilter.column == column
        });
    },

    onFiltersReloaded: function (filters) {
        var that = this;
        that.utils.showSpinner();

        that.tableFilterPreferences = filters;
        that.renderColumnFilters();
        that.resort(that.collection);
        that.renderSortColumns();

        window.setTimeout(function () {
            that.utils.hideSpinner();
            $.notify("Filters successfully reloaded", "success");
        }, 2000);
    },

    onFilterChanged: function (payload) {
        var that = this;

        var foundIndex = _.findIndex(that.tableFilterPreferences.tableColumnFilters, function (tcf) {
            return tcf.column == payload.columnFilter.column
                && tcf.dataType == payload.columnFilter.dataType
                && tcf.filterType == payload.columnFilter.filterType;
        });

        if (foundIndex > -1) {
            that.tableFilterPreferences.tableColumnFilters[foundIndex] = payload.columnFilter;
        } else {
            that.tableFilterPreferences.tableColumnFilters.push(payload.columnFilter);
        }

        that.filterFunctions[payload.columnFilter.column] = payload.filterFunction;

        if (payload.deferred) {
            if (_.keys(that.filterFunctions).length == (that.isSimple ? 4 : (that.variant == 'referral') ? 10 : 12) /* this is filter views count*/)
                that.filterCollectionWithFilterFunctions(that.filterFunctions);
        } else {
            that.filterCollectionWithFilterFunctions(that.filterFunctions);
        }
    },

    filterCollectionWithFilterFunctions: function (filterFunctions) {
        var that = this;
        var notEmptyFilterFunctionsKeys = _.keys(filterFunctions).filter(function (key) {
            return _.isFunction(filterFunctions[key]);
        });

        var filteredCollection = new MedsidePatientsCollections(that.collection.filter(function (model) {
                return _.reduce(notEmptyFilterFunctionsKeys, function (memo, fnKey) {
                    return memo && filterFunctions[fnKey](model.get(fnKey));
                }, true);
            }
        ), {id: that.id});

        that.resort(filteredCollection);
        that.renderPatientsTableBody(filteredCollection);
    },

    collectionValuesAsTsv: function () {

        var that = this;
        var asTable = that.getChildView("body").getCollection().models.map(function (model) {
            return model.attributes
        })
        var rowSplitter = "~~~";
        var valueSplitter = ";;;";
        var emptinessSymbol = "___";

        var formatDate = function (val) {
            return (val == '' || val == null || val == 0 ? emptinessSymbol : that.utils.longToDateTimeFormatted(Number(val), 'MM/DD/YYYY'));
        }

        var asTsv = asTable.map(function (model) {
            if (that.isSimple) {
                return (model.patient_name || emptinessSymbol) + valueSplitter
                    + formatDate(model.soc) + valueSplitter
                    + formatDate(model.status)
            }

            return (model.patient_name || emptinessSymbol) + valueSplitter
                + formatDate(model.referral_date) + valueSplitter
                + formatDate(model.soc) + valueSplitter
                + (that.variant != "referral" ? formatDate(model.transfer_date) + valueSplitter
                    + formatDate(model.status) + " " + (model.dc_type || emptinessSymbol) + valueSplitter : "").replace(/___ ___/g, "")
                + (model.admit || emptinessSymbol) + valueSplitter
                + (model.md || emptinessSymbol) + valueSplitter
                + (model.location || emptinessSymbol) + valueSplitter
                + (model.jencare_coordinators || emptinessSymbol).split(':')[0] + valueSplitter
                + (model.insurance || emptinessSymbol) + valueSplitter
                + (model.intake || emptinessSymbol) + valueSplitter
                + (model.cm_sn || emptinessSymbol)
        }).join(rowSplitter);

        var tsvHeader = "Patient" + valueSplitter
            + "Refferal" + valueSplitter
            + "SOC" + valueSplitter
            + (that.variant != "referral" ? "Transfer" + valueSplitter
                + "DC" + valueSplitter : "")
            + "Admit" + valueSplitter
            + "MD" + valueSplitter
            + "Location" + valueSplitter
            + "Coordinator" + valueSplitter
            + "Insurance" + valueSplitter
            + "Intake" + valueSplitter
            + "CM" + rowSplitter;
        if (that.isSimple) {
            tsvHeader = "Patient" + valueSplitter
                + "SOC" + valueSplitter
                + "DC" + rowSplitter;
        }

        return tsvHeader + asTsv;
    },

    onExportToPdf: function () {

        this.utils.downloadFileWithPost("/api/pdf/table/from/csv",
            ["caption=Patients", "content=" + this.collectionValuesAsTsv()]);
    },

    onExportToCsv: function () {
        var csv = this.collectionValuesAsTsv();
        csv = csv.replace(/,/g, ".").replace(/~~~/g, "\n").replace(/;;;/g, ",").replace(/___/g, "");
        var hiddenElement = document.createElement('a');
        hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
        hiddenElement.target = '_blank';
        hiddenElement.download = 'Patients.csv';
        hiddenElement.click();
        window.setTimeout(function () {
            hiddenElement.remove();
        }, 0);
    }
});

var PatientsRowView = Marionette.View.extend({
    tagName: 'tr',
    template: require('../../templates/organizations/organization-patients-row.html'),
    ui: {
        refpo: '[name="refpo"]',
        socpo: '[name="socpo"]',
        jfsv: '[name="jfspov"]',
        jfsvis: '[name="jfsvis"]',
        patient_profile: '[name="open_profile"]',
        rnsDocs: '.rns-docs'
    },
    events: {
        'click @ui.patient_profile': 'openIfPatientExists',
        'click @ui.rnsDocs': 'openDocumentsIfPatientExists'
    },

    templateContext: function () {
        var that = this;
        this.utils = new CommonUtils();
        return {
            formatDate: function (dt) {
                return (dt == '' || dt == null || dt == 0 ? '' : that.utils.longToDateTimeFormatted(Number(dt), 'MM/DD/YYYY'));
            },
            isSimple: that.isSimple,
            variant: that.variant,
            toUpper: function (value) {
                return value ? value.toUpperCase() : value;
            }
        }
    },

    initialize: function (options) {
        this.params = $.deparam(window.location.hash.replace('#organization/' + options.id + '/patients', '').replace('?', ''));
        this.sourceOrganization = this.params['sourceOrganization'];
        this.isSimple = options.isSimple;
        this.variant = options.variant || "";
    },

    onRender: function () {
        var that = this;
        var organizationPatientsViewRef = new OrganizationPatientPopoverView({
            reason: that.model.get('ref_reason'),
            comment: that.model.get('ref_comment'),
            audits: that.model.get('ref_audits')
        });
        var organizationPatientsViewSoc = new OrganizationPatientPopoverView({
            reason: that.model.get('soc_reason'),
            comment: that.model.get('soc_comment'),
            audits: that.model.get('soc_audits')
        });
        organizationPatientsViewRef.render();
        organizationPatientsViewSoc.render();

        that.ui.refpo.popover({
            content: organizationPatientsViewRef.el,
            template: '<div class="popover" role="tooltip"><div class="arrow"></div><div class="popover-title"></div><div class="popover-content"></div></div>',
            placement: 'right'
        })
            .on("show.bs.popover", function () {
                var self = $(this);
                $('.popover').each(function () {
                    if (self != $(this)) {
                        $(this).popover('hide');
                    }
                });
                $(this).data("bs.popover").tip().css(
                    {
                        //"max-width": "100%",
                        //"text-align": "right",
                        //"border-style": "solid",
                        "border-width": "3px"
                    }
                );

                $(this).data("bs.popover").arrow().css(
                    {
                        "display": "none"
                    }
                );
            })
            .on('shown.bs.popover', function (e) {
                var popover = $(this);

                /*if (popover.data("bs.popover").tip().css("top").charAt(0) == '-') {
                    popover.data("bs.popover").tip().css(
                        {
                            "top": "0px"
                        }
                    );
                }*/
                jQuery(this).parent().find('div.popover .close').on('click', function (e) {
                    popover.popover('hide');
                });
            })
            .on("hidden.bs.popover", function () {
                $(this).data("bs.popover").inState.click = false
            });

        that.ui.socpo.popover({
            content: organizationPatientsViewSoc.el,
            placement: 'right',
            template: '<div class="popover" role="tooltip"><div class="arrow"></div><div class="popover-title"></div><div class="popover-content"></div></div>'
        })
            .on("show.bs.popover", function () {
                var self = $(this);
                $('.popover').each(function () {
                    if (self != $(this)) {
                        $(this).popover('hide');
                    }
                });
                $(this).data("bs.popover").tip().css({
                    //"max-width": "100%",
                    //"text-align": "right",
                    //"border-style": "solid",
                    "border-width": "3px"
                });
                $(this).data("bs.popover").arrow().css(
                    {
                        "display": "none"
                    }
                );
            })
            .on('shown.bs.popover', function (e) {
                var popover = $(this);

                /*if (popover.data("bs.popover").tip().css("top").charAt(0) == '-') {
                    popover.data("bs.popover").tip().css(
                        {
                            "top": "0px"
                        }
                    );
                }*/
                jQuery(this).parent().find('div.popover .close').on('click', function (e) {
                    popover.popover('hide');
                });
            })
            .on("hidden.bs.popover", function () {
                $(this).data("bs.popover").inState.click = false
            });

        that.ui.jfsv.popover(
            {
                placement: "left",
                //template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-header test"></h3><div class="popover-body"></div></div>',
                template: '<div class="popover" role="tooltip"><div class="arrow"></div><div class="popover-title"></div><div class="popover-content"></div></div>',
                content: function () {
                    var div_id = "tmp-id-" + $.now();
                    return that.asyncShowJournalFrequencies(div_id, 'v_' + that.model.get('patient_id'), that.model.get('soc'));
                },
            }
        )
            .on("show.bs.popover", function () {
                var self = $(this);
                $('.popover').each(function () {
                    if (self != $(this)) {
                        $(this).popover('hide');
                    }
                });
                $(this).data("bs.popover").tip().css(
                    {
                        "max-width": "100%",
                        //"text-align": "right",
                        //"border-style": "solid",
                        "border-width": "3px"
                    }
                );

                $(this).data("bs.popover").arrow().css(
                    {
                        "display": "none"
                    }
                );
            })
            .on('shown.bs.popover', function (e) {
                var popover = $(this);

                popover.data("bs.popover").tip().css(
                    {
                        //"left": (Number($('body').width() - 1200) / 2) + "px",
                        //"right": (Number($('body').width() - 1200) / 2) + "px"
                        "left": "140px",
                        "right": "140px"
                    }
                );

                /*if (popover.data("bs.popover").tip().css("top").charAt(0) == '-') {
                    popover.data("bs.popover").tip().css(
                        {
                            "top": "0px"
                        }
                    );
                }*/

                jQuery(this).parent().find('div.popover .close').on('click', function (e) {
                    popover.popover('hide');
                });
            })
            .on("hidden.bs.popover", function () {
                $(this).data("bs.popover").inState.click = false
            });

        that.ui.jfsvis.popover(
            {
                placement: "left",
                template: '<div class="popover" role="tooltip"><div class="arrow"></div><div class="popover-title"></div><div class="popover-content"></div></div>',
                content: function () {
                    var div_id = "tmp-id-" + $.now();
                    return that.asyncShowJournalFrequenciesVisits(div_id, 'jfd_' + that.model.get('patient_id'), that.model.get('soc'));
                },
            }
        )
            .on("show.bs.popover", function () {
                var self = $(this);
                $('.popover').each(function () {
                    if (self != $(this)) {
                        $(this).popover('hide');
                    }
                });
                $(this).data("bs.popover").tip().css(
                    {
                        "max-width": "100%",
                        //"text-align": "right",
                        //"border-style": "solid",
                        "border-width": "3px"
                    }
                );

                $(this).data("bs.popover").arrow().css(
                    {
                        "display": "none"
                    }
                );
            })
            .on('shown.bs.popover', function (e) {
                var popover = $(this);

                popover.data("bs.popover").tip().css(
                    {
                        //"left": (Number($('body').width() - popover.width()) / 4) + "px"
                        "left": "200px",
                        "right": "200px"
                    }
                );

                /*if (popover.data("bs.popover").tip().css("top").charAt(0) == '-') {
                    popover.data("bs.popover").tip().css(
                        {
                            "top": "0px"
                        }
                    );
                }

                if (popover.data("bs.popover").tip().css("left").charAt(0) == '-') {
                    popover.data("bs.popover").tip().css(
                        {
                            "left": "10px"
                        }
                    );
                }*/

                jQuery(this).parent().find('div.popover .close').on('click', function (e) {
                    popover.popover('hide');
                });
            })
            .on("hidden.bs.popover", function () {
                $(this).data("bs.popover").inState.click = false
            });
    },


    asyncShowJournalFrequencies: function (div_id, patient, date) {
        var that = this;
        var url = "/api/organization/journal_frequencies?patient_id=" + patient + "&date=" + date;
        var method = "POST";


        $.ajax({
            type: method,
            url: url,
            statusCode: {
                200: function (response) {
                    if (response.list) {
                        var organizationPatientPopoverViewJF = new OrganizationPatientPopoverViewJF({
                            list: response.list
                        });
                        organizationPatientPopoverViewJF.render();
                        $('#' + div_id).html(organizationPatientPopoverViewJF.el);
                    }
                    else {
                        $('#' + div_id).html(response.responseText);
                    }

                },
                503: function (e) {
                    notificationsChannel.request('show:notification', e.responseJSON);

                },
                401: function (e) {
                    actionsChannel.request("redirect:to:login");

                },
                404: function (e) {
                    var error = JSON.parse(e.responseText);
                    $('#' + div_id).html(error.message);
                }
            },
            error: function (e) {
                console.log(e);
            }
        });
        return '<div id="' + div_id + '" style="text-align:left">Loading...</div>';
    },

    asyncShowJournalFrequenciesVisits: function (div_id, patient, date) {
        var that = this;
        var url = "/api/organization/journal_frequencies?patient_id=" + patient + "&date=" + date;
        var method = "POST";


        $.ajax({
            type: method,
            url: url,
            statusCode: {
                200: function (response) {
                    if (response.list) {
                        var organizationPatientPopoverViewJfVisits = new OrganizationPatientPopoverViewJfVisits({
                            list: response.list
                        });
                        organizationPatientPopoverViewJfVisits.render();
                        $('#' + div_id).html(organizationPatientPopoverViewJfVisits.el);
                    }
                    else {
                        $('#' + div_id).html(response.responseText);
                    }

                },
                503: function (e) {
                    notificationsChannel.request('show:notification', e.responseJSON);

                },
                401: function (e) {
                    actionsChannel.request("redirect:to:login");

                },
                404: function (e) {
                    var error = JSON.parse(e.responseText);
                    $('#' + div_id).html(error.message);
                }
            },
            error: function (e) {
                console.log(e);
            }
        });
        return '<div id="' + div_id + '" style="text-align:left;">Loading...</div>';
    },

    openIfPatientExists: function () {
        var that = this;
        that.doIfPatientExists(function (patientId) {
            window.open("/#person/" + patientId);
        });
        return false;
    },

    openDocumentsIfPatientExists: function () {
        var that = this;
        that.doIfPatientExists(function (patientId) {
            //window.open("/#documents?page-size=" + Constants.pageCapacity + "&object_type=xml&like_name=_CCDA&page=0&DOCUMENT_PATIENT=" + patientId);
            window.open("/#documents?page-size=" + Constants.pageCapacity + "&object_type=pdf&page=0&DOCUMENT_PATIENT=" + patientId);
        });
    },

    doIfPatientExists: function (fn) {
        var that = this;
        var params = [];
        params.push("organizationId=" + that.sourceOrganization);//org_id);
        params.push("externalId=" + that.model.get('p_id'));

        $.ajax({
            type: "GET",
            url: '/api/person/external-id?' + params.join('&'),
            statusCode: {
                200: function (response) {
                    if (response && response.responseText) {
                        fn(response.responseText);
                    }
                    else
                        $.notify("This Patient was not found in R&S", "error");

                },
                503: function (e) {
                    notificationsChannel.request('show:notification', e.responseJSON);

                },
                401: function (e) {
                    actionsChannel.request("redirect:to:login");

                },
                400: function (e) {
                    $.notify("This Patient was not found in R&S", "error");
                }
            }
        });
    }
});

var EmptyView = Marionette.View.extend({
    tagName: 'tr',
    template: _.template(_.reduce(_.map(_.range(0), function (value) {
        return '<td>-</td>'
    }), function (memo, str) {
        return memo + str;
    }, ""))
});

var PatientsTableBody = Marionette.CollectionView.extend({
    tagName: 'tbody',
    childView: PatientsRowView,
    emptyView: EmptyView,

    childViewEvents: {},

    initialize: function (options) {
        this.collection = options.collection;
        this.isSimple = options.isSimple;
        this.variant = options.variant;
    },

    getCollection: function () {
        return this.collection;
    },

    childViewOptions: function () {
        return {
            isSimple: this.isSimple,
            variant: this.variant
        }
    }

});

module.exports = OrganizationPatientsView;


//////////////////
// WEBPACK FOOTER
// ./app/views/organizations/organization-patients.js
// module id = 285
// module chunks = 0